import type { FC, SVGProps } from "react";
import React from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const AngleDownLight: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="angle down icon">
      {/* <title>angle down icon</title> */}
      <path
        fill="currentColor"
        d="M362.7 203.9l-159.1 144c-6.125 5.469-15.31 5.469-21.44 0L21.29 203.9C14.73 197.1 14.2 187.9 20.1 181.3C26.38 174.4 36.5 174.5 42.73 180.1L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188C369.8 187.9 369.3 197.1 362.7 203.9z"
      />
    </svg>
  );
};

export default AngleDownLight;
